module.exports = __webpack_public_path__ + "media/account.f78278dd.mp3";